<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WORK_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="this.$options.name"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'select'"
              @select-changed="onChangeBizCodes"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="comboUseYn"
              :selected="frame0.selectData.COD_DTSVC_USE_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMY_00021'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_WORK_LIST") }}</h4>
      </div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_gridTop_wrap">
            <div class="btn_wrapL">
              <sui-button
                type="button"
                :class="expandAll ? 'comm_btn_treeOpen' : 'comm_btn_treeClose'"
                @click="onTreeGridCollapseToggle"
              />
              <!-- <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onClickExpand"
              >
                {{ $t("MSG_BTN_ALL_SPREAD") }}
              </sui-button>
              <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onClickCollapse"
              >
                {{ $t("MSG_BTN_ALL_FOLD") }}
              </sui-button> -->
            </div>
            <div class="btn_wrapR">
              <sui-button
                v-permission:delete="this.$options.name"
                type="button"
                class="comm_btn_gridTop"
                @click="onDelTask"
              >
                {{ $t("MSG_BTN_DEL") }}
              </sui-button>
              <sui-button
                v-permission:create="'PGE_CMY_00021'"
                type="button"
                class="comm_btn_gridTop"
                @click="onNewTask"
              >
                {{ $t("MSG_BTN_ADD_NEW") }}
              </sui-button>
            </div>
          </div>
          <sui-tree
            ref="taskTree"
            v-bind="treeData"
            class="brdG01 pd20"
            style="height:450px; overflow:auto;"
            :editable="contentEditable"
            @item-click="onItemClick"
          />
        </div>
        <div class="btnbox" />
        <div class="inbox">
          <sui-page-tab-box-type
            ref="tab"
            :tabItems="tabItems"
            :defaultTabIndex="defaultTabIndex"
            :setCurrentTabComponent="setCurrentTabComponent"
            @change-tab-idx="onChangeTabIdx"
          >
            <container
              :is="currentTabComponent"
              :pageId="this.$options.name"
              :selectedTreeData="selectedTreeData"
              :multiLanguageId="multiLanguageId"
              @onSearchClick="onTabSearch"
              @page-deactivate="handleChildDeactivated"
              @page-activate="handleChildActivated"
            />
          </sui-page-tab-box-type>
        </div>
      </div>
      <sui-popup
        v-model="isShownPopupNew"
        :title="$t('MSG_TIT_TASK_RGST')"
      >
        <p01
          :pageId="this.$options.name"
          :taskId="frame0.selectTaskId"
          :taskIdLvlName="frame0.taskIdLvlName"
          :taskIdLvl="frame0.taskIdLvl"
          :pTaskLvl="frame0.pTaskLvl"
          :parentTaskId="frame0.parentTaskId"
          :multiLanguageId="multiLanguageId"
          :taskIdInputSize="taskIdInputSize"
          @onNewClick="onNewTask"
          @close="popNewClose()"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import t01 from './components/PGE_CMY_00021_T01.vue';
import p01 from './components/PGE_CMY_00021_P01.vue';

export default {
  name: 'PGE_CMY_00021', // eslint-disable-line vue/name-property-casing
  components: {
    t01,
    p01,
  },
  extends: BasePage,
  data() {
    return {
      expandAll: false,
      contentEditable: false,
      pageName: 'PGE_CMY_00021',
      codes: CommonConstants.selectOptions(),
      multiLanguageId: '',
      taskIdInputSize: '',
      frame0: {
        selectData: {
          COD_DTSVC_USE_YN: {
            label: '',
            key: '',
          },
        },
        taskId: '',
        selectTaskId: '',
        taskIdLvl: '',
        pTaskLvl: '',
        taskIdLvlName: '',
        parentTaskId: '',
      },
      isShownPopupNew: false,
      selectedTreeData: {},
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_DTL_CNTN'),
          component: t01,
        },
      ],
      currentTabComponent: t01,
      treeData: {
        data: [{
          id: '',
          parentId: '',
          // folderYn: 'Y',
          level: 0,
          value: '',
          text: '',
          // opened: false,
          // children: [],
        }],
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadData() {
      http.request(this.$options.name, 'DTS_CMY_00028', {
      }).then(res => {
        this.setTreeData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    setTreeData(data) {
      const rootNode = utils.getMakeTreeData({
        id: 'taskId',
        parentId: 'parentTaskId',
        level: 'taskLvl',
        value: 'taskName',
        text: '{{taskName}}',
      }, data, true);

      this.treeData = { data: rootNode };
    },
    setCurrentTabComponent(component) {
      console.log('processTab.setCurrentTabComponent() was called.');
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onSearchClick() {
      let searchLevel1Code = '';
      let searchLevel2Code = '';
      let searchLevel3Code = '';
      const selectedLevel1Code = this.$refs.taskIdSelect.getSelected1LevelTask().key;
      const selectedLevel2Code = this.$refs.taskIdSelect.getSelected2LevelTask().key;
      const selectedLevel3Code = this.$refs.taskIdSelect.getSelected3LevelTask().key;

      // eslint-disable-next-line no-nested-ternary
      let searchTaskCode = (this.selectedBizCode.length < 2 ? ''
        : this.$refs.taskIdSelect.getSelected3LevelTask().key === ' ' ? ''
          : utils.trim(this.$refs.taskIdSelect.getSelected3LevelTask().key));

      if (selectedLevel1Code !== 'ALL' && selectedLevel2Code === 'ALL' && selectedLevel3Code === ' ') {
        searchTaskCode = selectedLevel1Code.substr(0, 6);
        searchLevel2Code = '';
        searchLevel3Code = '';
      } else if (selectedLevel1Code !== 'ALL' && selectedLevel2Code !== 'ALL' && selectedLevel3Code === ' ') {
        searchTaskCode = selectedLevel2Code.substr(0, 9);
        searchLevel1Code = selectedLevel1Code;
        searchLevel2Code = selectedLevel2Code;
        searchLevel3Code = '';
      }

      if (selectedLevel3Code !== ' ') {
        searchLevel1Code = selectedLevel1Code;
        searchLevel2Code = selectedLevel2Code;
        searchLevel3Code = selectedLevel3Code;
      }

      const codeValue = this.frame0.selectData;
      const queryParams = {
        searchLevel1Code: searchLevel1Code || '',
        searchLevel2Code: searchLevel2Code || '',
        searchLevel3Code: searchLevel3Code || '',
        searchTaskCode: searchTaskCode || '',
        searchUseYn: utils.trim(codeValue.COD_DTSVC_USE_YN.key) || '',
      };

      http.request(this.$options.name, 'DTS_CMY_00028', {
        query: queryParams,
      }).then(res => {
        this.setTreeData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onResetClick() {
      this.$refs.taskIdSelect.reset();
      this.$refs.comboUseYn.reset();
    },
    onItemClick(node) {
      this.selectedTreeData = node.data;
    },
    onTreeGridCollapseToggle() {
      if (this.expandAll) {
        this.onClickExpand();
      } else {
        this.onClickCollapse();
      }
      this.expandAll = !this.expandAll;
    },
    onClickExpand() {
      this.treeData.data.forEach(child => {
        // eslint-disable-next-line no-param-reassign
        child.opened = true;
      });
    },
    onClickCollapse() {
      this.treeData.data.forEach(child => {
        // eslint-disable-next-line no-param-reassign
        child.opened = false;
      });
    },
    onDelTask() {
      if (this.$refs.taskTree.getSelection().length === 0) {
        //utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return;
      }

      const dataParams = {
        taskId: this.$refs.taskTree.getSelection()[0].taskId,
        taskLvl: this.$refs.taskTree.getSelection()[0].taskLvl,
      };

      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00043', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, this.onSearchClick);
          const deleteData = {
            data: {
              taskId: '',
              taskUpId: '',
              taskUseYn: '',
              arylOrd: '',
              taskContents: '',
              taskMlngId: '',
            },
          };
          this.onItemClick(deleteData);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onNewTask() {
      const taskIdLength = this.$refs.taskTree.getSelection().length;

      if (taskIdLength === 0) {
        this.frame0.taskIdLvlName = 'TSK_';
        this.frame0.taskId = '';
        this.frame0.parentTaskId = '';
        this.frame0.taskIdLvl = '';
        this.taskIdInputSize = 'width:100px';
      } else if (taskIdLength > 0) {
        const preTaskId = this.$refs.taskTree.getSelection()[0].taskId;
        this.frame0.parentTaskId = this.$refs.taskTree.getSelection()[0].parentTaskId;
        this.frame0.selectTaskId = this.$refs.taskTree.getSelection()[0].taskId;
        this.frame0.taskIdLvl = utils.toCharNum(this.$refs.taskTree.getSelection()[0].taskLvl);

        if (!utils.startsWith(this.frame0.parentTaskId, 'TSK')) {
          this.frame0.pTaskLvl = '2';
        } else {
          this.frame0.pTaskLvl = '3';
        }

        if (this.frame0.taskIdLvl === '1') {
          this.frame0.taskIdLvlName = `${preTaskId.substr(0, 6)}`;
          this.frame0.parentTaskId = preTaskId;
        } else if (this.frame0.taskIdLvl === '2') {
          this.frame0.taskIdLvlName = `${preTaskId.substr(0, 9)}`;
          this.frame0.parentTaskId = preTaskId;
        } else if (this.frame0.taskIdLvl === '3') {
          utils.messageBox('warning', this.$t('MSG_ALT_BUSI_REG_LEVEL3'));
          return;
        }
      }

      this.isShownPopupNew = !this.isShownPopupNew;
    },
    onTabSearch() {
      this.onSearchClick();
    },
    popNewClose() {
      this.isShownPopupNew = !this.isShownPopupNew;
      this.onSearchClick();
    },
  },
};
</script>
<style scoped>
</style>
